// File#: _1_expandable-table
// Usage: codyhouse.co/license

$(document).ready(function() {
  var ExTable = function(element) {
    this.element = element;
    this.rows = this.element.getElementsByClassName('js-ex-table__body')[0].getElementsByTagName('tr');
    this.layout = '';
    getTableLayout(this);
    initTable(this);
  };

  function initTable(table) {
    // init aria-expanded attributes for 'More' buttons
    var moreButtons = table.element.getElementsByClassName('js-ex-table__btn');
    for(var i = 0; i < moreButtons.length; i++) {
      var rowExpanded = moreButtons[i].closest('.ex-table__row--show-more-content') ? true : false;
      moreButtons[i].setAttribute('aria-expanded', rowExpanded);
    }
    
    // custom event emitted when window is resized
    table.element.addEventListener('update-table', function(event){
      checkTableLayout(table);
      resetTableStyle(table);
    });

    // detect click on more Button - toggle additional table content
    table.element.addEventListener('click', function(event){
      var button = event.target.closest('.js-ex-table__btn');
      if(!button) return;
      var tableRow = button.parentNode.parentNode,
        showMore = !Util.hasClass(tableRow, 'ex-table__row--show-more-content');
      Util.toggleClass(tableRow, 'ex-table__row--show-more-content', showMore);
      button.setAttribute('aria-expanded', showMore);
      if(!showMore) resetRowStyle(table, tableRow, showMore);
      resetTableStyle(table);
    });
  };

  function getTableLayout(table) {
    table.layout = getComputedStyle(table.element, ':before').getPropertyValue('content').replace(/\'|"/g, '');
  };

  function checkTableLayout(table) { // check table layout
    getTableLayout(table);
    Util.toggleClass(table.element, tableExpandedLayoutClass, table.layout != 'collapsed');
    Util.addClass(table.element, 'ex-table--loaded');
  };

  function resetTableStyle(table) { // update table style according to layout
    for(var i = 0; i < table.rows.length; i++) {
      if( Util.hasClass(table.rows[i], 'ex-table__row--show-more-content')) {
        resetRowStyle(table, table.rows[i], true);
      }
    }
  };

  function resetRowStyle(table, row, showBool) {
    var content = row.getElementsByClassName('js-ex-table__more-content');
    if(content.length== 0 ) return;
    if(table.layout == 'expanded') {
      resetExpandedRowStyle(table, row, content[0], showBool);
    } else {
      resetCompressedRowStyle(row, content[0]);
    }
  };

  function resetExpandedRowStyle(table, row, content, showBool) {
    // row style applied when table layout is expanded
    if(showBool) {
      var offsetHeight = content.offsetHeight,
        cells = row.children;
      for(var i = 0; i < cells.length; i++) {
        cells[i].setAttribute('style', 'border-bottom-width:'+offsetHeight+'px;');
      }
      content.setAttribute('style', 'top: '+parseFloat(row.offsetHeight + row.offsetTop - offsetHeight)+'px;');
    } else {
      resetCompressedRowStyle(row, content);
    }
  };

  function resetCompressedRowStyle(row, content) {
    // row style applied when table layout is compressed
    content.removeAttribute('style');
    var cells = row.children;
    for(var i = 0; i < cells.length; i++) {
      cells[i].removeAttribute('style');
    }
  };

  var tables = document.getElementsByClassName('js-ex-table'),
    tableExpandedLayoutClass = 'ex-table--expanded';
  if( tables.length > 0 ) {
    var j = 0,
      arrayTables = [];
    for( var i = 0; i < tables.length; i++) {
      var beforeContent = getComputedStyle(tables[i], ':before').getPropertyValue('content');
      if(beforeContent && beforeContent !='' && beforeContent !='none') {
        (function(i){ arrayTables.push(new ExTable(tables[i]));})(i);
        j = j + 1;
      } else {
        Util.addClass(tables[i], 'ex-table--loaded');
      }
    }
    
    if(j > 0) {
      var resizingId = false,
        customEvent = new CustomEvent('update-table');
      window.addEventListener('resize', function(event){ // update table layout on resize
        clearTimeout(resizingId);
        resizingId = setTimeout(doneResizing, 300);
      });

      function doneResizing() {
        for( var i = 0; i < arrayTables.length; i++) {
          (function(i){arrayTables[i].element.dispatchEvent(customEvent)})(i);
        };
      };

      (window.requestAnimationFrame) // init tables
        ? window.requestAnimationFrame(doneResizing)
        : doneResizing();
    }
  }
});